import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BannerData {
  message: string;
  link?: string;
  type: 'error' | 'info' | 'warning';
}

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  private bannerSubject = new BehaviorSubject<BannerData | null>(null);
  banner$ = this.bannerSubject.asObservable();

  show(data: BannerData) {
    this.bannerSubject.next(data);
  }

  hide() {
    this.bannerSubject.next(null);
  }
}
